var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_782_309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H0V17H17V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_782_309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_782_309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H0V17H17V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_782_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.72921C10.625 5.7512 9.67364 4.95837 8.5 4.95837C7.32636 4.95837 6.375 5.7512 6.375 6.72921C6.375 7.7072 7.32636 8.50004 8.5 8.50004C9.67364 8.50004 10.625 9.29288 10.625 10.2709C10.625 11.2489 9.67364 12.0417 8.5 12.0417C7.32636 12.0417 6.375 11.2489 6.375 10.2709",
    stroke: "#F45600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.25V4.95833",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.25V4.95833",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.0417V12.7501",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 8.50011C15.5833 12.41 12.41 15.5834 8.49999 15.5834C4.58997 15.5834 1.41663 12.41 1.41663 8.50011C1.41663 4.59009 4.58997 1.41675 8.49999 1.41675",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 4.25009V1.41675H12.75",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0416 4.95842L15.5833 1.41675",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.3c900d0deff3eca17ea589b5b9315a5e.svg";
export { ForwardRef as ReactComponent };